module.exports = "img/flags/TK.09871f8.png";